<template>
  <form action="#" class="form-wizard">
    <div class="form-wizard-progress py-5 px-3">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <h1><slot name="heading"></slot></h1>
            <p>Schritt {{ this.current + 1}} von {{ this.steps.length }}</p>
            <div class="progress">
              <div
                  class="progress-bar progress-bar-striped bg-info"
                  role="progressbar"
                  v-bind="progressBarBindings"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <keep-alive>
        <component
            :is="currentComponent"
            v-bind="currentStep"
            :form="form"
            v-on="$listeners"
        ></component>
      </keep-alive>
    </div>
  </form>
</template>
<script>
import DefaultStep from './DefaultStep'

export default {
  props: {
    current: {
      type: Number,
      required: true
    },
    steps: {
      type: Array,
      default () {
        return []
      }
    },
    form: {
      type: Object,
      required: true
    }
  },

  provide () {
    return {
      wizard: this
    }
  },

  computed: {
    currentComponent () {
      return this.currentStep.component || DefaultStep
    },

    currentStep () {
      return this.steps[this.current]
    },

    isOnFirstPage () {
      return this.current === 0
    },

    isOnLastPage () {
      return this.current === this.steps.length - 1
    },

    progressBarBindings () {
      return {
        style: {
          width: ((this.current + 1) / this.steps.length * 100) + '%'
        },
        'aria-valuenow': this.current,
        'aria-valuemin': 0,
        'aria-valuemax':this.steps.length - 1
      }
    }
  }
}
</script>
